import { ScrollView } from "../ScrollView.js";
import { IScrollViewScale } from "./IScrollViewScale.js";

export class ScrollViewScalePillarbox implements IScrollViewScale {
    public getScale(view: ScrollView): number {
        return view.height / view.contentHeight;
    }
}